import React from 'react';
import { Column, GridContainer, Row, Typography } from '@vp/react-vp-ui-library';
import { getLocalizedText as t } from '@vp-dst/localization-util';

export default function Steps() {
  return (
    <GridContainer>
      <Row>
        <Column span={3}>
          <div style={{ marginTop: 10, marginBottom: 10 }}>
            <Typography size={6} purpose="heading" style={{ textTransform: 'uppercase' }}>
              1. {t('select-your-product')}
            </Typography>
          </div>
        </Column>
        <Column span={3}>
          <div style={{ marginTop: 10, marginBottom: 10 }}>
            <Typography size={6} purpose="heading" style={{ textTransform: 'uppercase' }}>
              2. {t('upload-and-edit-design')}
            </Typography>
          </div>
        </Column>
        <Column span={3}>
          <div style={{ marginTop: 10, marginBottom: 10 }}>
            <Typography size={6} purpose="heading" style={{ textTransform: 'uppercase' }}>
              3. {t('review-and-approve')}
            </Typography>
          </div>
        </Column>
        <Column span={3}>
          <div style={{ marginTop: 10, marginBottom: 10 }}>
            <Typography size={6} purpose="heading" style={{ textTransform: 'uppercase' }}>
              4. {t('select-paper-stock-and-finishes')}
            </Typography>
          </div>
        </Column>
      </Row>
    </GridContainer>
  );
}
